// extracted by mini-css-extract-plugin
var _1 = "iqBuo";
export { _1 as "base" }
